function ToggleActive( element ) 
{
    var activeContainers = document.querySelectorAll( '.prdt-nav-option-container.active' )
    activeContainers.forEach( function ( el ) 
    {
        el.classList.remove( 'active' );
    });

    element.classList.add( 'active' );

    var pairKey = element.getAttribute( 'data-pair-key' );

    var colBlocks = document.querySelectorAll( '.hp-product-card-wrap' );
    colBlocks.forEach( function( el ) 
    {
        el.style.display = 'none';
    });

    var selectedColBlocks = document.querySelectorAll( '.hp-product-card-wrap[data-pairing-text-img="' + pairKey + '"]' );
    selectedColBlocks.forEach( function( el ) 
    {
        el.style.display = 'flex';
    });
}

document.addEventListener( 'DOMContentLoaded', function() 
{
    var firstOption = document.querySelector( '.prdt-nav-option-container' );
    
    if ( firstOption ) 
    {
        ToggleActive( firstOption );
    }

    var navBarOptions = document.querySelectorAll( '.prdt-nav-option-container' );

    navBarOptions.forEach( function( option ) 
    {
        option.addEventListener( 'click', function() 
        {
            ToggleActive( this );
        });
    });

});